// api/moderation.api.ts
import axiosInstance from './axios-instance';
import { ModerationType, ResourceType } from '../types/moderation.types';

export interface CreateReportDTO {
  targetId: string;
  targetType: ResourceType;
  violations: ModerationType[];
  detail?: string;
}

export const moderationApi = {
  // Submit a report
  createReport: async (report: CreateReportDTO) => {
    const { data } = await axiosInstance.post(`/api/v1/ai/reports`, report);
    return data;
  },

  // Get violation types/options
  getViolationTypes: async () => {
    const { data } = await axiosInstance.get(`/api/v1/ai/reports/violations`);
    return data;
  }
};
